/** @jsx h */
import h from './h';

export default (
    <value>
        <document>
            <paragraph />
        </document>
    </value>
);
